import { render, staticRenderFns } from "./SingleThumbnail.vue?vue&type=template&id=c2a5bf7c"
import script from "./SingleThumbnail.vue?vue&type=script&lang=js"
export * from "./SingleThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports